import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects.item');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;
declare let WizRoute: any;

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-projects-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.projects.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageProjectsItemComponent implements OnInit, OnDestroy {
    public id: string = '';
    public isNew: boolean = false;
    public tab: string = 'design';
    public loading: boolean = true;

    public project: any = this.defaultProject();

    public simResults: any = null;
    public recommendations: any[] = [];
    public digitalTwin: any = {};
    public technologyAnalysis: any = null;
    public isSimulating: boolean = false;
    public isRecommending: boolean = false;
    public isLoadingTwin: boolean = false;
    public isSeedingField: boolean = false;
    public isRunningTechAnalysis: boolean = false;
    public simHistory: any[] = [];
    public workflow: any = this.defaultWorkflow();
    public isGeneratingReport: boolean = false;
    public reviewComment: string = '';
    public reviewSeverity: string = 'info';
    public reviewDecisionNote: string = '';
    public reviewReviewer: string = '';
    public reviewReviewerId: string = '';
    public reviewerOptions: any[] = [];
    public isRequestingReview: boolean = false;
    public isAssigningReviewer: boolean = false;
    public isSavingComment: boolean = false;
    public isDecidingReview: boolean = false;
    public activeReviewDecision: string = '';
    public designInputErrors: string[] = [];
    public documentOverview: any = this.defaultDocumentOverview();
    public documentSearchText: string = '';
    public documentSearchResults: any[] = [];
    public hasSearchedDocuments: boolean = false;
    public documentSearchEmptyReason: string = '';
    public isUploadingDocument: boolean = false;
    public uploadDocumentProgress: number = 0;
    public uploadDocumentStage: string = '';
    public parsingDocumentId: string = '';
    public isLoadingDocuments: boolean = false;
    public isSyncingParserModels: boolean = false;
    public isSearchingDocuments: boolean = false;
    public documentTagFilter: string = '';
    public editingDocumentTagId: string = '';
    public documentTagDraft: string = '';
    public savingDocumentTagId: string = '';
    public documentTagError: string = '';
    public selectedDocumentIds: string[] = [];
    public bulkDocumentTagDraft: string = '';
    public isSavingBulkDocumentTags: boolean = false;
    public bulkDocumentTagError: string = '';
    public designChatInput: string = '';
    public designChatBrief: any = {};
    public designChatMessages: any[] = this.defaultDesignChatMessages();
    public designChatAppliedFields: any[] = [];
    public designChatAppliedKeys: string[] = [];
    public designChatProgress: number = 0;
    public designChatError: string = '';
    public isDesignChatSending: boolean = false;
    public designChatUseLLM: boolean = true;
    public designChatExamples: string[] = [
        'GV80 파워 트렁크를 18kg, 82도, 4초, 24V로 설계해줘',
        '전동 도어, 다축 힌지, 22kg, 70도, 3.5초, -30~85℃',
        '에어로 파츠를 12V, 6kg, 35도, 2초 조건으로 설계'
    ];

    public workflowTabs: any[] = [
        { key: 'design', label: '설계', step: '01' },
        { key: 'documents', label: '문서', step: '02' },
        { key: 'simulation', label: '시뮬레이션', step: '03' },
        { key: 'digital_twin', label: '디지털 트윈', step: '04' },
        { key: 'review', label: '검토', step: '05' },
        { key: 'reports', label: '리포트', step: '06' }
    ];
    public digitalTwinTools: any[] = [
        {
            path: '/digital-twin',
            label: 'DT 운영 모니터',
            eyebrow: 'Live monitor',
            desc: '현재 프로젝트 ID를 유지한 상태로 정격 대비 부하율, 효율, 열, 전류 위험 알람을 실시간 확인합니다.',
            action: '모니터링',
            tone: 'cyan'
        },
        {
            path: '/digital-twin/kinematics',
            label: '3D 기구학',
            eyebrow: '3D kinematics',
            desc: '힌지, COG, 장착점, 액추에이터 로드를 프로젝트 설계값 기준으로 3D 공간에서 검토합니다.',
            action: '3D 보기',
            tone: 'violet'
        },
        {
            path: '/digital-twin/mcu',
            label: 'MCU 검증/실측 입력',
            eyebrow: 'MCU validation',
            desc: 'MCU 전압·전류·홀센서 실측 샘플을 입력하고 시뮬레이션 응답과 비교해 검증 근거를 남깁니다.',
            action: '입력/검증',
            tone: 'emerald'
        },
        {
            path: '/digital-twin/pid',
            label: 'PID 분석',
            eyebrow: 'PID analysis',
            desc: '프로젝트 기준 PID 파라미터 정합성과 스텝 응답을 확인합니다.',
            action: '분석',
            tone: 'orange'
        }
    ];
    public partTypes = ['파워 트렁크', '전동 도어', '전동 시트', '에어로 파츠', '사이드 스텝', '선루프'];
    public hingeTypes = ['단축', '다축', '4절링크'];
    public statuses = [
        { value: 'draft', label: '초안' },
        { value: 'in_progress', label: '진행중' },
        { value: 'completed', label: '완료' }
    ];
    private designValidationRules: any[] = [
        { key: 'voltage', label: '전압', unit: 'V', min: 5, max: 48 },
        { key: 'target_angle', label: '목표 각도', unit: '°', min: 1, max: 180 },
        { key: 'target_time', label: '목표 시간', unit: '초', min: 0.1, max: 60 },
        { key: 'weight', label: '무게', unit: 'kg', min: 0.1, max: 500 },
        { key: 'temperature_min', label: '최저 온도', unit: '°C', min: -40, max: 90 },
        { key: 'temperature_max', label: '최고 온도', unit: '°C', min: -40, max: 90 },
        { key: 'cog_x', label: '무게 중심 X', unit: 'm', min: -2, max: 2 },
        { key: 'cog_y', label: '무게 중심 Y', unit: 'm', min: -2, max: 2 },
        { key: 'cog_z', label: '무게 중심 Z', unit: 'm', min: -2, max: 2 },
        { key: 'hinge_x', label: '힌지 X', unit: 'm', min: -2, max: 2 },
        { key: 'hinge_y', label: '힌지 Y', unit: 'm', min: -2, max: 2 },
        { key: 'hinge_z', label: '힌지 Z', unit: 'm', min: -2, max: 2 },
        { key: 'mount_x', label: '장착점 X', unit: 'm', min: -2, max: 2 },
        { key: 'mount_y', label: '장착점 Y', unit: 'm', min: -2, max: 2 },
        { key: 'mount_z', label: '장착점 Z', unit: 'm', min: -2, max: 2 }
    ];

    private routerSub: any = null;
    private designTitleAutoGenerated: boolean = false;
    private designChatHighlightTimer: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    private apiErrorMessage(res: any, fallback: string): string {
        return res?.data?.message || res?.message || (typeof res?.data === 'string' ? res.data : '') || fallback;
    }

    private resetDesignChat() {
        this.designChatInput = '';
        this.designChatBrief = {};
        this.designChatMessages = this.defaultDesignChatMessages();
        this.designChatAppliedFields = [];
        this.designChatAppliedKeys = [];
        this.designChatProgress = 0;
        this.designChatError = '';
        this.isDesignChatSending = false;
        this.designTitleAutoGenerated = false;
        if (this.designChatHighlightTimer) {
            clearTimeout(this.designChatHighlightTimer);
            this.designChatHighlightTimer = null;
        }
    }

    public onProjectTitleChange() {
        this.designTitleAutoGenerated = false;
    }

    public async useDesignChatExample(example: string) {
        this.designChatInput = example;
        this.designChatError = '';
        await this.service.render();
    }

    private designChatHistory() {
        return this.designChatMessages
            .filter((item: any) => item?.role === 'user' || item?.role === 'assistant')
            .slice(-8)
            .map((item: any) => ({ role: item.role, content: item.content || '' }));
    }

    private scrollDesignChatToBottom() {
        setTimeout(() => {
            const container = document.getElementById('project-design-chat-messages');
            if (container) container.scrollTop = container.scrollHeight;
        }, 0);
    }

    private applyDesignChatFields(applied: any[]) {
        const allowedKeys = [
            'vehicle', 'part_type', 'hinge_type', 'weight', 'target_angle',
            'target_time', 'voltage', 'temperature_min', 'temperature_max'
        ];
        const accepted: any[] = [];
        for (const item of applied || []) {
            const key = item?.project_key || '';
            if (!allowedKeys.includes(key)) continue;
            if (key === 'part_type' && !this.partTypes.includes(item.value)) continue;
            if (key === 'hinge_type' && !this.hingeTypes.includes(item.value)) continue;
            this.project[key] = item.value;
            accepted.push(item);
        }

        const acceptedKeys = accepted.map((item: any) => item.project_key);
        if (
            (acceptedKeys.includes('vehicle') || acceptedKeys.includes('part_type')) &&
            (!(this.project.title || '').trim() || this.designTitleAutoGenerated)
        ) {
            this.project.title = [this.project.vehicle, this.project.part_type]
                .filter((value: any) => String(value || '').trim())
                .join(' ');
            this.designTitleAutoGenerated = true;
            acceptedKeys.push('title');
        }

        this.designChatAppliedFields = accepted;
        this.designChatAppliedKeys = Array.from(new Set(acceptedKeys));
        this.refreshDesignInputErrors();

        if (this.designChatHighlightTimer) clearTimeout(this.designChatHighlightTimer);
        this.designChatHighlightTimer = setTimeout(async () => {
            this.designChatAppliedKeys = [];
            this.designChatHighlightTimer = null;
            await this.service.render();
        }, 3500);
    }

    public designFieldWasApplied(key: string) {
        return this.designChatAppliedKeys.includes(key);
    }

    public designChatFillClass(item: any) {
        if (item?.classification === 'explicit') {
            return 'border-cyan-200 bg-cyan-50 text-cyan-800 dark:border-cyan-300/30 dark:bg-cyan-300/10 dark:text-cyan-100';
        }
        if (item?.classification === 'assumption') {
            return 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-300/30 dark:bg-amber-300/10 dark:text-amber-100';
        }
        return 'border-violet-200 bg-violet-50 text-violet-800 dark:border-violet-300/30 dark:bg-violet-300/10 dark:text-violet-100';
    }

    public designChatValue(item: any) {
        const units: any = {
            weight: 'kg',
            targetAngle: '°',
            targetTime: '초',
            voltage: 'V',
            tempMin: '℃',
            tempMax: '℃'
        };
        return `${item?.value ?? '-'}${units[item?.key] || ''}`;
    }

    public designChatConfidence(item: any) {
        const confidence = Number(item?.confidence);
        if (!Number.isFinite(confidence)) return '';
        return `${Math.round(confidence * 100)}%`;
    }

    public async sendDesignChat() {
        const message = (this.designChatInput || '').trim();
        if (!message || this.isDesignChatSending) return;

        const history = this.designChatHistory();
        this.designChatMessages = [
            ...this.designChatMessages,
            { role: 'user', content: message, fill: [] }
        ];
        this.designChatInput = '';
        this.designChatError = '';
        this.isDesignChatSending = true;
        await this.service.render();
        this.scrollDesignChatToBottom();

        let res: any = null;
        try {
            res = await wiz.call('design_chat', {
                message,
                brief: JSON.stringify(this.designChatBrief || {}),
                history: JSON.stringify(history),
                use_llm: String(this.designChatUseLLM)
            });
        } catch (error) {
            res = { code: 500, data: { message: '설계 채팅 서버에 연결하지 못했습니다.' } };
        }

        if (res?.code === 200) {
            const data = res.data || {};
            this.designChatBrief = data.brief || this.designChatBrief;
            this.designChatProgress = Number(data.progress || 0);
            this.applyDesignChatFields(data.applied || []);
            this.designChatMessages = [
                ...this.designChatMessages,
                {
                    role: 'assistant',
                    content: data.content || '설계 요구를 분석했습니다.',
                    fill: data.fill || [],
                    ai_meta: data.ai_meta || {},
                    next_question: data.next_question || ''
                }
            ];
        } else {
            this.designChatError = this.apiErrorMessage(res, '설계 요구를 분석하지 못했습니다.');
            this.designChatMessages = [
                ...this.designChatMessages,
                { role: 'assistant', content: this.designChatError, fill: [], error: true }
            ];
        }

        this.isDesignChatSending = false;
        await this.service.render();
        this.scrollDesignChatToBottom();
    }

    public async onDesignChatKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
        event.preventDefault();
        await this.sendDesignChat();
    }

    public async ngOnInit() {
        await this.service.init();
        this.id = this.routeProjectId();
        this.isNew = this.id === 'new';
        this.syncTab();

        if (!this.isNew) {
            await this.loadProject();
            await this.loadHistory();
            await this.loadWorkflow();
        }
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleRouteChange();
            }
        });
        this.loading = false;
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.designChatHighlightTimer) clearTimeout(this.designChatHighlightTimer);
    }

    private defaultProject() {
        return {
            title: '', vehicle: '', part_type: '파워 트렁크', status: 'draft',
            voltage: 12, target_angle: 80, target_time: 4, weight: 12,
            cog_x: 0.15, cog_y: 0, cog_z: -0.02,
            hinge_x: 0, hinge_y: 0, hinge_z: 0,
            mount_x: 0.05, mount_y: 0.12, mount_z: -0.03,
            hinge_type: '단축', temperature_min: -30, temperature_max: 90
        };
    }

    private defaultDesignChatMessages() {
        return [
            {
                role: 'assistant',
                content: '만들고 싶은 액추에이터 설계를 자연어로 작성해 주세요. 차종, 가동부, 무게, 목표 각도·시간, 전압, 온도 조건을 분류해 왼쪽 설계 브리프에 바로 반영합니다.',
                fill: [],
                ai_meta: { label: '프로젝트 생성 도우미', mode: 'guide' }
            }
        ];
    }

    private defaultWorkflow() {
        return {
            case: null,
            simulations: [],
            reports: [],
            verification: {},
            digitalTwin: {},
            review: {},
            documents: this.defaultDocumentOverview(),
            process: [],
            gates: [],
            nextAction: {},
            reviewers: [],
            recommendations: [],
            summary: {}
        };
    }

    private defaultDocumentOverview() {
        return {
            documents: [],
            requirements: [],
            pendingRequirements: [],
            approvedRequirements: [],
            audits: [],
            parserModels: [],
            availableTags: [],
            tagPolicy: {
                maxTags: 10,
                maxLength: 24,
                maxBulkUpdates: 50,
                allowedCharacters: '한글, 영문, 숫자, 공백, 밑줄(_), 하이픈(-)'
            },
            uploadPolicy: {
                maxBytes: 25 * 1024 * 1024,
                maxLabel: '25.0MB',
                extensions: ['.pdf', '.xlsx'],
                transport: 'multipart'
            },
            vector: {},
            stats: { documents: 0, activeDocuments: 0, disposedDocuments: 0, pending: 0, approved: 0, chunks: 0 }
        };
    }

    private resetProjectContext() {
        this.project = this.defaultProject();
        this.simResults = null;
        this.recommendations = [];
        this.digitalTwin = {};
        this.technologyAnalysis = null;
        this.simHistory = [];
        this.workflow = this.defaultWorkflow();
        this.documentOverview = this.defaultDocumentOverview();
        this.documentSearchText = '';
        this.documentSearchResults = [];
        this.hasSearchedDocuments = false;
        this.documentSearchEmptyReason = '';
        this.documentTagFilter = '';
        this.editingDocumentTagId = '';
        this.documentTagDraft = '';
        this.savingDocumentTagId = '';
        this.documentTagError = '';
        this.selectedDocumentIds = [];
        this.bulkDocumentTagDraft = '';
        this.isSavingBulkDocumentTags = false;
        this.bulkDocumentTagError = '';
        this.resetDesignChat();
    }

    private rememberProjectId(id: string) {
        if (!id || id === 'new') return;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    private async handleRouteChange() {
        const nextId = this.routeProjectId();
        const projectChanged = nextId !== this.id;
        this.id = nextId;
        this.isNew = this.id === 'new';
        this.rememberProjectId(this.id);
        this.syncTab();
        if (projectChanged) {
            if (this.isNew) {
                this.resetProjectContext();
            } else {
                this.loading = true;
                await this.service.render();
                await this.loadProject();
                await this.loadHistory();
                await this.loadWorkflow();
                this.loading = false;
            }
        }
        await this.service.render();
    }

    private routeProjectId() {
        const match = location.pathname.match(/^\/projects\/([^\/\?#]+)/);
        if (match && match[1]) return decodeURIComponent(match[1]);
        return WizRoute.segment.id || '';
    }

    private routeTab() {
        const match = location.pathname.match(/^\/projects\/[^\/\?#]+\/([^\/\?#]+)/);
        if (match && match[1]) return decodeURIComponent(match[1]);
        return WizRoute.segment.tab || '';
    }

    private syncTab() {
        const rawTab = this.routeTab() || 'design';
        const nextTab = rawTab === 'verification' ? 'review' : rawTab;
        if (this.workflowTabs.some((item: any) => item.key === nextTab)) {
            this.tab = nextTab;
            return;
        }
        this.tab = 'design';
    }

    private projectUrl(tab: string = this.tab) {
        return `/projects/${this.id}/${tab}`;
    }

    public currentTabLabel() {
        const item = this.workflowTabs.find((tabItem: any) => tabItem.key === this.tab);
        return item ? item.label : '설계';
    }

    private async loadProject() {
        const { code, data } = await wiz.call("get", { id: this.id });
        if (code !== 200) {
            this.service.href('/projects');
            return;
        }
        this.rememberProjectId(this.id);
        this.project = data;
        this.refreshDesignInputErrors();
    }

    private async loadHistory() {
        const { code, data } = await wiz.call("results", { project_id: this.id });
        if (code === 200) this.simHistory = data || [];
    }

    private async loadWorkflow() {
        const { code, data } = await wiz.call("workflow", { id: this.id });
        if (code === 200) {
            this.workflow = this.normalizeWorkflow(data || this.workflow);
            this.digitalTwin = this.workflow.digitalTwin || {};
            this.documentOverview = this.workflow.documents || this.defaultDocumentOverview();
            this.reviewerOptions = data?.reviewers || this.workflow.reviewers || this.reviewerOptions || [];
            this.syncReviewForm();
        }
    }

    private isRequirementStep(step: any) {
        return step?.key === 'requirements' || step?.key === 'requirement' || step?.label === '\uC694\uAD6C\uC870\uAC74';
    }

    private isDesignStep(step: any) {
        return step?.key === 'design' || step?.label === '설계' || step?.label === '설계안';
    }

    private isDesignCompletedByAction(workflow: any) {
        const status = workflow?.project?.status || this.project?.status || '';
        const currentStep = workflow?.summary?.currentStep || '';
        return status === 'in_progress' || status === 'completed' || ['documents', 'simulation', 'digital_twin', 'review', 'reports'].includes(currentStep);
    }

    private mergedDesignState(requirement: any, design: any, workflow: any) {
        if (this.isDesignCompletedByAction(workflow)) return 'done';
        const states = [requirement?.state, design?.state].filter(Boolean);
        if (states.length > 0 && states.every((state: string) => state === 'done')) return 'done';
        if (states.includes('current') || states.includes('done')) return 'current';
        return design?.state || requirement?.state || 'current';
    }

    private normalizeWorkflow(payload: any) {
        const workflow = { ...this.defaultWorkflow(), ...(payload || {}) };
        const process = Array.isArray(workflow.process) ? workflow.process : [];
        const requirementStep = process.find((step: any) => this.isRequirementStep(step));
        const designStep = process.find((step: any) => this.isDesignStep(step));

        if (requirementStep && designStep) {
            const merged = {
                ...designStep,
                key: 'design',
                label: '설계',
                tab: 'design',
                desc: '요구 성능·전기 제약·기구 조건 구조화',
                state: this.mergedDesignState(requirementStep, designStep, workflow)
            };
            workflow.process = [
                merged,
                ...process.filter((step: any) => !this.isRequirementStep(step) && !this.isDesignStep(step))
            ].map((step: any, index: number) => ({ ...step, index: index + 1 }));
        } else {
            workflow.process = process.map((step: any, index: number) => ({
                ...step,
                label: this.isDesignStep(step) ? '설계' : step.label,
                state: this.isDesignStep(step) && this.isDesignCompletedByAction(workflow) ? 'done' : step.state,
                index: index + 1
            }));
        }

        const gates = Array.isArray(workflow.gates) ? workflow.gates : [];
        const requirementGate = gates.find((gate: any) => this.isRequirementStep(gate));
        const designGate = gates.find((gate: any) => this.isDesignStep(gate));
        if (requirementGate && designGate) {
            workflow.gates = [
                {
                    ...designGate,
                    key: 'design',
                    label: '설계',
                    desc: '요구 성능·전기 제약·기구 조건 저장',
                    state: this.mergedDesignState(requirementGate, designGate, workflow)
                },
                ...gates.filter((gate: any) => !this.isRequirementStep(gate) && !this.isDesignStep(gate))
            ];
        } else {
            workflow.gates = gates.map((gate: any) => ({
                ...gate,
                label: this.isDesignStep(gate) ? '설계' : gate.label,
                state: this.isDesignStep(gate) && this.isDesignCompletedByAction(workflow) ? 'done' : gate.state
            }));
        }

        workflow.process = workflow.process.map((step: any) => ({
            ...step,
            metrics: this.workflowStepMetricsForStep(step, workflow.summary || {})
        }));

        return workflow;
    }

    private syncReviewForm() {
        const review = this.workflow.review || {};
        let reviewerId = (review.reviewer_id || '').trim();
        const reviewer = (review.reviewer || '').trim();
        if (!reviewerId && reviewer && reviewer !== '검토자 미지정') {
            const matched = this.reviewerOptions.find((item: any) => {
                return item.id === reviewer || item.name === reviewer || item.email === reviewer || item.label === reviewer;
            });
            reviewerId = matched?.id || '';
        }
        if (!reviewerId && !this.reviewReviewerId && this.reviewerOptions.length > 0) {
            reviewerId = this.reviewerOptions[0].id;
        }
        if (reviewerId) this.reviewReviewerId = reviewerId;
        const selected = this.selectedReviewer();
        this.reviewReviewer = selected?.label || selected?.name || reviewer || this.reviewReviewer || '';
    }

    public selectedReviewer() {
        return this.reviewerOptions.find((item: any) => item.id === this.reviewReviewerId) || null;
    }

    public selectedReviewerEmail() {
        const selected = this.selectedReviewer();
        return selected?.email || '';
    }

    public onReviewerChange() {
        const selected = this.selectedReviewer();
        this.reviewReviewer = selected?.label || selected?.name || '';
    }

    public hasReviewerTarget() {
        return Boolean(this.reviewReviewerId || (this.reviewReviewer || '').trim());
    }

    private reviewerPayload() {
        const selected = this.selectedReviewer();
        return {
            reviewer_id: selected?.id || this.reviewReviewerId || '',
            reviewer: selected?.label || selected?.name || (this.reviewReviewer || '').trim()
        };
    }

    private numberOrNull(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const num = Number(value);
        return Number.isFinite(num) ? num : null;
    }

    private collectDesignInputErrors() {
        const errors: string[] = [];
        for (const rule of this.designValidationRules) {
            const value = this.numberOrNull(this.project?.[rule.key]);
            if (value === null) {
                errors.push(`${rule.label} 값을 입력해주세요.`);
                continue;
            }
            if (value < rule.min || value > rule.max) {
                errors.push(`${rule.label}은(는) ${rule.min}~${rule.max}${rule.unit} 범위로 입력해주세요.`);
            }
        }
        const tempMin = this.numberOrNull(this.project?.temperature_min);
        const tempMax = this.numberOrNull(this.project?.temperature_max);
        if (tempMin !== null && tempMax !== null && tempMin > tempMax) {
            errors.push('최저 온도는 최고 온도보다 클 수 없습니다.');
        }
        return errors;
    }

    public refreshDesignInputErrors() {
        this.designInputErrors = this.collectDesignInputErrors();
        return this.designInputErrors;
    }

    private async ensureDesignInputsValid(actionLabel: string) {
        const errors = this.refreshDesignInputErrors();
        if (errors.length === 0) return true;
        if (!this.isNew && this.tab !== 'design') {
            await this.switchTab('design');
        }
        await this.service.render();
        await this.service.modal.error(`${actionLabel} 전 설계 입력 범위를 확인해주세요.\n- ${errors.slice(0, 6).join('\n- ')}`);
        return false;
    }

    public async save() {
        if (!(await this.ensureDesignInputsValid(this.isNew ? '프로젝트 생성' : '프로젝트 저장'))) return false;
        const payload = {
            ...this.project,
            status: this.project.status === 'draft' ? 'in_progress' : this.project.status
        };
        if (this.isNew) {
            const { code, data } = await wiz.call("create", { data: JSON.stringify(payload) });
            if (code === 200) {
                const createdId = typeof data === 'string' ? data : (data?.id || data?.data?.id || '');
                this.service.href(createdId ? `/projects/${createdId}/design` : '/projects');
                return true;
            }
            return false;
        } else {
            const res = await wiz.call("update", { id: this.id, data: JSON.stringify(payload) });
            if (res?.code !== 200) {
                await this.service.modal.error(this.apiErrorMessage(res, "프로젝트 저장에 실패했습니다."));
                return false;
            }
            this.project = payload;
            await this.loadProject();
            await this.loadWorkflow();
            await this.service.render();
            return true;
        }
    }

    public async deleteProject() {
        const ok = await this.service.modal.show({
            title: '프로젝트 삭제',
            message: '이 프로젝트를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
            action: '삭제',
            status: 'error'
        });
        if (ok) {
            const res = await wiz.call("delete", { id: this.id });
            if (res && res.code === 200) {
                this.service.href('/projects');
            } else {
                await this.service.modal.error(res?.data?.message || '삭제에 실패했습니다.');
            }
        }
    }

    public async runSimulation() {
        if (!(await this.ensureDesignInputsValid('시뮬레이션 실행'))) return;
        this.isSimulating = true;
        this.simResults = null;
        await this.service.render();
        const { code, data } = await wiz.call("run_simulation", { id: this.id });
        this.isSimulating = false;
        if (code === 200) {
            this.simResults = data;
            await this.loadHistory();
            await this.loadWorkflow();
            this.technologyAnalysis = null;
        }
        await this.service.render();
    }

    public async getRecommendations() {
        this.isRecommending = true;
        this.recommendations = [];
        await this.service.render();
        const { code, data } = await wiz.call("recommend", { id: this.id });
        this.isRecommending = false;
        if (code === 200) this.recommendations = data || [];
        await this.service.render();
    }

    public async generateReport() {
        this.isGeneratingReport = true;
        await this.service.render();
        const { code, data } = await wiz.call("generate_report", { id: this.id });
        this.isGeneratingReport = false;
        if (code === 200) {
            await this.loadWorkflow();
            await this.service.modal.success("리포트가 생성되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage({ code, data }, "리포트 생성에 실패했습니다."));
        }
        await this.service.render();
    }

    public async refreshDigitalTwin() {
        if (!this.id || this.isNew || this.isLoadingTwin) return;
        this.isLoadingTwin = true;
        await this.service.render();
        const res = await wiz.call("digital_twin_snapshot", { id: this.id });
        this.isLoadingTwin = false;
        if (res && res.code === 200) {
            this.digitalTwin = res.data || {};
            await this.loadWorkflow();
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "디지털 트윈 검증 정보를 불러오지 못했습니다."));
        }
        await this.service.render();
    }

    public async seedFieldDataDemo() {
        if (!this.id || this.isNew || this.isSeedingField) return;
        this.isSeedingField = true;
        await this.service.render();
        const res = await wiz.call("seed_field_demo", { id: this.id });
        this.isSeedingField = false;
        if (res && res.code === 200) {
            this.digitalTwin = res.data?.snapshot || {};
            await this.loadWorkflow();
            await this.service.modal.success("프로젝트 필드 센서 데모 데이터가 적재되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "필드 센서 데이터를 적재하지 못했습니다."));
        }
        await this.service.render();
    }

    public async runTechnologyAnalysis() {
        if (!this.id || this.isNew || this.isRunningTechAnalysis) return;
        this.isRunningTechAnalysis = true;
        this.technologyAnalysis = null;
        await this.service.render();
        const res = await wiz.call("run_technology_analysis", { id: this.id });
        this.isRunningTechAnalysis = false;
        if (res && res.code === 200) {
            this.technologyAnalysis = res.data || {};
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "기술 목표 분석을 실행하지 못했습니다."));
        }
        await this.service.render();
    }

    private applyDocumentOverview(payload: any) {
        const overview = payload?.overview || payload?.data?.overview || payload || this.defaultDocumentOverview();
        this.documentOverview = { ...this.defaultDocumentOverview(), ...overview };
        this.workflow.documents = this.documentOverview;
        this.documentSearchResults = [];
        this.hasSearchedDocuments = false;
        this.documentSearchEmptyReason = '';
        if (this.activeDocumentCount() === 0) {
            this.documentSearchEmptyReason = 'no_documents';
        }
    }

    public activeDocumentCount(): number {
        const count = this.documentOverview?.stats?.activeDocuments;
        if (count !== null && count !== undefined) return Number(count) || 0;
        return (this.documentOverview?.documents || []).filter((item: any) => item?.storage_state === 'active').length;
    }

    public approvedDocumentChunkCount(): number {
        return Number(this.documentOverview?.vector?.approvedChunks || 0);
    }

    public availableDocumentTags(): any[] {
        return Array.isArray(this.documentOverview?.availableTags)
            ? this.documentOverview.availableTags
            : [];
    }

    public documentTags(document: any): string[] {
        const tags = document?.tags || document?.metadata?.tags || [];
        return Array.isArray(tags) ? tags : [];
    }

    public filteredDocuments(): any[] {
        const documents = Array.isArray(this.documentOverview?.documents)
            ? this.documentOverview.documents
            : [];
        if (!this.documentTagFilter) return documents;
        return documents.filter((document: any) => this.documentTags(document).includes(this.documentTagFilter));
    }

    public selectDocumentTagFilter(tag: string = '') {
        this.documentTagFilter = this.documentTagFilter === tag ? '' : tag;
        this.documentSearchResults = [];
        this.hasSearchedDocuments = false;
        this.documentSearchEmptyReason = '';
        this.service.render();
    }

    public canSearchDocuments(): boolean {
        return !!(this.documentSearchText || '').trim() || !!this.documentTagFilter;
    }

    public startDocumentTagEdit(document: any) {
        if (!document?.id || document?.storage_state !== 'active' || this.savingDocumentTagId) return;
        this.editingDocumentTagId = document.id;
        this.documentTagDraft = this.documentTags(document).join(', ');
        this.documentTagError = '';
        this.service.render();
    }

    public cancelDocumentTagEdit() {
        if (this.savingDocumentTagId) return;
        this.editingDocumentTagId = '';
        this.documentTagDraft = '';
        this.documentTagError = '';
        this.service.render();
    }

    private normalizeDocumentTags(value: string): { tags: string[]; error: string } {
        const policy = this.documentOverview?.tagPolicy || {};
        const maxTags = Number(policy.maxTags || 10);
        const maxLength = Number(policy.maxLength || 24);
        const rawTags = String(value || '').split(',');
        const tags: string[] = [];
        const seen = new Set<string>();
        for (const raw of rawTags) {
            const tag = raw.trim().replace(/^#+/, '').trim().replace(/\s+/g, ' ').toLowerCase();
            if (!tag) continue;
            if (tag.length > maxLength) {
                return { tags: [], error: `태그는 ${maxLength}자 이하로 입력해주세요.` };
            }
            if (!/^[0-9A-Za-z가-힣][0-9A-Za-z가-힣 _-]*$/.test(tag)) {
                return { tags: [], error: '태그는 한글, 영문, 숫자, 공백, 밑줄(_), 하이픈(-)만 사용할 수 있습니다.' };
            }
            if (!seen.has(tag)) {
                seen.add(tag);
                tags.push(tag);
            }
        }
        if (tags.length > maxTags) {
            return { tags: [], error: `문서당 태그는 최대 ${maxTags}개까지 저장할 수 있습니다.` };
        }
        return { tags, error: '' };
    }

    public async saveDocumentTags(document: any) {
        if (!document?.id || this.savingDocumentTagId) return;
        const normalized = this.normalizeDocumentTags(this.documentTagDraft);
        if (normalized.error) {
            this.documentTagError = normalized.error;
            await this.service.render();
            return;
        }

        this.savingDocumentTagId = document.id;
        this.documentTagError = '';
        await this.service.render();
        try {
            const res = await wiz.call('document_update_tags', {
                id: this.id,
                document_id: document.id,
                tags: JSON.stringify(normalized.tags)
            });
            if (res && res.code === 200) {
                this.applyDocumentOverview(res.data);
                this.editingDocumentTagId = '';
                this.documentTagDraft = '';
            } else {
                this.documentTagError = this.apiErrorMessage(res, '문서 태그 저장에 실패했습니다.');
            }
        } catch (error: any) {
            this.documentTagError = error?.message || '문서 태그 저장 중 오류가 발생했습니다.';
        } finally {
            this.savingDocumentTagId = '';
            await this.service.render();
        }
    }

    public isDocumentSelected(document: any): boolean {
        return !!document?.id && this.selectedDocumentIds.includes(document.id);
    }

    public selectedDocumentCount(): number {
        return this.selectedDocumentIds.length;
    }

    public toggleDocumentSelection(document: any, event: any) {
        if (!document?.id || document?.storage_state !== 'active' || this.isSavingBulkDocumentTags) return;
        const selected = !!event?.target?.checked;
        const ids = new Set(this.selectedDocumentIds);
        if (selected) ids.add(document.id);
        else ids.delete(document.id);
        this.selectedDocumentIds = Array.from(ids);
        this.bulkDocumentTagError = '';
        this.service.render();
    }

    public selectFilteredActiveDocuments() {
        if (this.isSavingBulkDocumentTags) return;
        const ids = new Set(this.selectedDocumentIds);
        for (const document of this.filteredDocuments()) {
            if (document?.id && document?.storage_state === 'active') ids.add(document.id);
        }
        this.selectedDocumentIds = Array.from(ids);
        this.bulkDocumentTagError = '';
        this.service.render();
    }

    public clearDocumentSelection() {
        if (this.isSavingBulkDocumentTags) return;
        this.selectedDocumentIds = [];
        this.bulkDocumentTagError = '';
        this.service.render();
    }

    public async applyBulkDocumentTags() {
        if (this.isSavingBulkDocumentTags) return;
        if (this.selectedDocumentIds.length === 0) {
            this.bulkDocumentTagError = '업무 태그를 적용할 활성 문서를 선택해주세요.';
            await this.service.render();
            return;
        }
        const normalized = this.normalizeDocumentTags(this.bulkDocumentTagDraft);
        if (normalized.error) {
            this.bulkDocumentTagError = normalized.error;
            await this.service.render();
            return;
        }
        const actionDescription = normalized.tags.length > 0
            ? `${normalized.tags.map((tag: string) => '#' + tag).join(', ')} 목록으로 대체`
            : '모두 제거';
        const confirmed = await this.service.modal.show({
            title: '선택 문서 태그 일괄 대체',
            message: `선택한 ${this.selectedDocumentIds.length}개 활성 문서의 기존 태그를 ${actionDescription}합니다. 계속하시겠습니까?`,
            action: '태그 대체',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.isSavingBulkDocumentTags = true;
        this.bulkDocumentTagError = '';
        await this.service.render();
        try {
            const updates = this.selectedDocumentIds.map((documentId: string) => ({
                document_id: documentId,
                tags: normalized.tags
            }));
            const res = await wiz.call('document_bulk_update_tags', {
                id: this.id,
                updates: JSON.stringify(updates)
            });
            if (res && res.code === 200) {
                this.applyDocumentOverview(res.data);
                this.selectedDocumentIds = [];
                this.bulkDocumentTagDraft = '';
            } else {
                this.bulkDocumentTagError = this.apiErrorMessage(res, '문서 태그 일괄 저장에 실패했습니다.');
            }
        } catch (error: any) {
            this.bulkDocumentTagError = error?.message || '문서 태그 일괄 저장 중 오류가 발생했습니다.';
        } finally {
            this.isSavingBulkDocumentTags = false;
            await this.service.render();
        }
    }

    public documentUploadLimitLabel(): string {
        return this.documentOverview?.uploadPolicy?.maxLabel || '25.0MB';
    }

    private documentUploadLimitBytes(): number {
        return Number(this.documentOverview?.uploadPolicy?.maxBytes || 25 * 1024 * 1024);
    }

    private validateDocumentFile(file: any): string {
        const name = String(file?.name || '');
        const extension = name.includes('.') ? `.${name.split('.').pop()?.toLowerCase()}` : '';
        if (!['.pdf', '.xlsx'].includes(extension)) {
            return 'PDF 또는 XLSX 파일만 업로드할 수 있습니다.';
        }
        const size = Number(file?.size || 0);
        if (size <= 0) return '빈 파일은 업로드할 수 없습니다.';
        if (size > this.documentUploadLimitBytes()) {
            return `${this.documentUploadLimitLabel()} 이하 파일만 업로드할 수 있습니다.`;
        }
        return '';
    }

    public documentStatusLabel(status: string): string {
        const labels: any = {
            uploaded: '저장 완료',
            parsing: '파싱 중',
            pending_review: '검수 대기',
            parsed: '파싱 완료',
            parse_error: '파싱 오류',
            disposed: '폐기됨'
        };
        return labels[status] || status || '-';
    }

    public documentParseStatusLabel(status: string): string {
        const labels: any = {
            queued: '대기',
            waiting: '수동 대기',
            running: '처리 중',
            completed: '완료',
            error: '오류'
        };
        return labels[status] || status || '-';
    }

    public async loadDocuments() {
        if (!this.id || this.isNew || this.isLoadingDocuments) return;
        this.isLoadingDocuments = true;
        await this.service.render();
        const res = await wiz.call('document_overview', { id: this.id });
        this.isLoadingDocuments = false;
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '문서 정보를 불러오지 못했습니다.'));
        }
        await this.service.render();
    }

    public async uploadDocument() {
        if (!this.id || this.isNew || this.isUploadingDocument) return;
        const files: any = await this.service.file.select({ accept: '.pdf,.xlsx,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', multiple: false });
        const file = files && files.length ? files[0] : null;
        if (!file) return;
        const validationError = this.validateDocumentFile(file);
        if (validationError) {
            await this.service.modal.error(validationError);
            return;
        }
        this.isUploadingDocument = true;
        this.uploadDocumentProgress = 0;
        this.uploadDocumentStage = '업로드 준비 중';
        await this.service.render();
        try {
            const form = new FormData();
            form.append('id', this.id);
            form.append('filename', file.name);
            form.append('mime_type', file.type || '');
            form.append('file_size', String(file.size || 0));
            form.append('file', file, file.name);
            const rawResponse: any = await this.service.file.upload(
                '/wiz/api/page.projects.item/document_upload_base64',
                form,
                async (percent: number) => {
                    const progress = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
                    if (progress !== this.uploadDocumentProgress) {
                        this.uploadDocumentProgress = progress;
                        this.uploadDocumentStage = progress >= 100
                            ? '전송 완료 · 암호화 저장 및 파싱 중'
                            : `파일 전송 중 ${progress}%`;
                        await this.service.render();
                    }
                }
            );
            const res: any = rawResponse?.responseJSON || rawResponse;
            if (res && res.code === 200) {
                this.uploadDocumentProgress = 100;
                this.applyDocumentOverview(res.data);
                await this.loadWorkflow();
                const uploaded = res.data?.document || {};
                if (uploaded.parse_status === 'error') {
                    this.uploadDocumentStage = '보안 저장 완료 · 파싱 확인 필요';
                    await this.service.modal.error(`파일은 안전하게 저장했지만 파싱하지 못했습니다. ${uploaded.message || '문서 목록에서 재파싱해주세요.'}`);
                } else {
                    this.uploadDocumentStage = '업로드 및 파싱 완료';
                }
            } else {
                await this.service.modal.error(this.apiErrorMessage(res, '문서 업로드에 실패했습니다.'));
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '문서 업로드 중 오류가 발생했습니다.');
        } finally {
            this.isUploadingDocument = false;
            await this.service.render();
        }
    }

    public async parseDocument(document: any) {
        if (!document || !document.id || this.parsingDocumentId) return;
        this.parsingDocumentId = document.id;
        await this.service.render();
        try {
            const res = await wiz.call('document_parse', { id: this.id, document_id: document.id });
            if (res && res.code === 200) {
                this.applyDocumentOverview(res.data);
                await this.loadWorkflow();
            } else {
                await this.loadDocuments();
                await this.service.modal.error(this.apiErrorMessage(res, '문서 파싱에 실패했습니다.'));
            }
        } catch (error: any) {
            await this.loadDocuments();
            await this.service.modal.error(error?.message || '문서 파싱 중 오류가 발생했습니다.');
        } finally {
            this.parsingDocumentId = '';
            await this.service.render();
        }
    }

    public async approveDocumentRequirement(item: any) {
        if (!item || !item.id) return;
        const res = await wiz.call('document_approve_requirement', { id: this.id, requirement_id: item.id });
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
            await this.loadProject();
            await this.loadWorkflow();
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '검수 후보 승인에 실패했습니다.'));
        }
        await this.service.render();
    }

    public async rejectDocumentRequirement(item: any) {
        if (!item || !item.id) return;
        const res = await wiz.call('document_reject_requirement', { id: this.id, requirement_id: item.id, reason: '사용자 반려' });
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
            await this.loadWorkflow();
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '검수 후보 반려에 실패했습니다.'));
        }
        await this.service.render();
    }

    public async approveAllDocumentRequirements() {
        if (!this.id || this.isNew) return;
        const res = await wiz.call('document_approve_all', { id: this.id });
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
            await this.loadProject();
            await this.loadWorkflow();
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '검수 후보 일괄 승인에 실패했습니다.'));
        }
        await this.service.render();
    }

    public async disposeDocument(document: any) {
        if (!document || !document.id) return;
        const ok = await this.service.modal.show({
            title: '문서 폐기',
            message: `${document.original_name || '문서'}를 폐기하시겠습니까? 저장 파일과 추출 요구사항·검색 청크가 삭제되고 감사 로그만 남습니다.`,
            action: '폐기',
            status: 'error'
        });
        if (!ok) return;
        const res = await wiz.call('document_dispose', { id: this.id, document_id: document.id, reason: '사용자 폐기' });
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
            await this.loadWorkflow();
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '문서 폐기에 실패했습니다.'));
        }
        await this.service.render();
    }

    public async searchDocuments() {
        if (!this.id || this.isNew || !this.canSearchDocuments() || this.isSearchingDocuments) return;
        const hasQuery = !!(this.documentSearchText || '').trim();
        this.documentSearchResults = [];
        this.hasSearchedDocuments = false;
        if (this.activeDocumentCount() === 0) {
            this.documentSearchEmptyReason = 'no_documents';
            this.hasSearchedDocuments = true;
            await this.service.render();
            return;
        }
        if (hasQuery && this.approvedDocumentChunkCount() === 0) {
            this.documentSearchEmptyReason = 'no_approved_content';
            this.hasSearchedDocuments = true;
            await this.service.render();
            return;
        }
        this.isSearchingDocuments = true;
        this.documentSearchEmptyReason = '';
        await this.service.render();
        try {
            const res = await wiz.call('document_search', {
                id: this.id,
                query: (this.documentSearchText || '').trim(),
                tags: JSON.stringify(this.documentTagFilter ? [this.documentTagFilter] : [])
            });
            if (res && res.code === 200) {
                this.documentSearchResults = res.data?.rows || [];
                this.hasSearchedDocuments = true;
                this.documentSearchEmptyReason = this.documentSearchResults.length > 0 ? '' : 'no_matches';
            } else {
                await this.service.modal.error(this.apiErrorMessage(res, '문서 검색에 실패했습니다.'));
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '문서 검색 중 오류가 발생했습니다.');
        } finally {
            this.isSearchingDocuments = false;
            await this.service.render();
        }
    }

    public async syncParserModels() {
        if (!this.id || this.isNew || this.isSyncingParserModels) return;
        this.isSyncingParserModels = true;
        await this.service.render();
        const res = await wiz.call('document_sync_parser_models', { id: this.id });
        this.isSyncingParserModels = false;
        if (res && res.code === 200) {
            this.applyDocumentOverview(res.data);
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, '파서 모델 동기화에 실패했습니다.'));
        }
        await this.service.render();
    }

    public digitalTwinStatusClass(level: string) {
        if (level === 'critical') return 'border-red-200 bg-red-50 text-red-700';
        if (level === 'warning') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (level === 'good') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return 'border-cyan-200 bg-cyan-50 text-cyan-700';
    }

    public digitalTwinToolCardClass(tone: string) {
        const map: any = {
            cyan: 'border-cyan-200 bg-cyan-50/70 text-cyan-700',
            violet: 'border-violet-200 bg-violet-50/70 text-violet-700',
            emerald: 'border-emerald-200 bg-emerald-50/70 text-emerald-700',
            orange: 'border-orange-200 bg-orange-50/70 text-orange-700'
        };
        return map[tone] || map.cyan;
    }

    public digitalTwinToolButtonClass(tone: string) {
        const map: any = {
            cyan: 'border-cyan-200 text-cyan-700 hover:bg-cyan-50',
            violet: 'border-violet-200 text-violet-700 hover:bg-violet-50',
            emerald: 'border-emerald-200 text-emerald-700 hover:bg-emerald-50',
            orange: 'border-orange-200 text-orange-700 hover:bg-orange-50'
        };
        return map[tone] || map.cyan;
    }

    public digitalTwinSourceClass(source: string) {
        if (source === 'field' || source === 'real-measurement') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (source === 'synthetic') return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public deviationValueClass(value: any) {
        const deviation = Number(value || 0);
        if (deviation >= 20) return 'text-red-700';
        if (deviation >= 10) return 'text-amber-700';
        return 'text-cyan-700';
    }

    public openDigitalTwinTool(path: string) {
        if (!this.id || this.isNew) return;
        this.service.href(`${path}?project_id=${encodeURIComponent(this.id)}`);
    }

    public failedValidationGates() {
        const gate = this.workflow.digitalTwin?.validationGate || this.digitalTwin?.validationGate || {};
        return gate.failedGates || [];
    }

    public validationFailedCount() {
        const gate = this.workflow.digitalTwin?.validationGate || this.digitalTwin?.validationGate || {};
        return Number(gate.failedCount || this.failedValidationGates().length || 0);
    }

    public gateActionLabel(gate: any) {
        if (gate?.actionLabel) return gate.actionLabel;
        const labels: any = {
            design_input: '설계 입력 확인',
            simulation_success: '시뮬레이션 실행',
            data_source_confirmed: '실측 데이터 입력',
            deviation_pass: '편차 확인'
        };
        return labels[gate?.key] || '확인';
    }

    public async goGateAction(gate: any) {
        if (gate?.key === 'data_source_confirmed') {
            this.openDigitalTwinTool('/digital-twin/mcu');
            return;
        }
        const tabs: any = {
            design_input: 'design',
            simulation_success: 'simulation',
            data_source_confirmed: 'digital_twin',
            deviation_pass: 'digital_twin'
        };
        await this.switchTab(gate?.actionTab || tabs[gate?.key] || 'digital_twin');
    }

    public dataSourceTrustLabel() {
        const dataSource = this.digitalTwin?.dataSource || {};
        return dataSource.trusted ? '승인 근거' : '승인 불가';
    }

    public dataSourceTrustClass() {
        const dataSource = this.digitalTwin?.dataSource || {};
        return dataSource.trusted ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700';
    }

    public async requestReview() {
        if (this.isRequestingReview) return;
        this.isRequestingReview = true;
        await this.service.render();
        const reviewer = this.reviewerPayload();
        const res = await wiz.call("request_review", {
            id: this.id,
            ...reviewer
        });
        this.isRequestingReview = false;
        if (res && res.code === 200) {
            await this.loadWorkflow();
            await this.service.modal.success("검토 요청이 생성되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "검토 요청을 생성하지 못했습니다."));
        }
        await this.service.render();
    }

    public async assignReviewer() {
        const reviewer = this.reviewerPayload();
        if (!reviewer.reviewer_id && !reviewer.reviewer) {
            await this.service.modal.error("검토자를 선택해주세요.");
            return;
        }
        if (this.isAssigningReviewer) return;
        this.isAssigningReviewer = true;
        await this.service.render();
        let res: any = null;
        try {
            res = await wiz.call("assign_reviewer", {
                id: this.id,
                review_id: this.workflow.review?.id || '',
                ...reviewer
            });
        } catch (error: any) {
            res = { code: 500, message: error?.message || '' };
        }
        if (!res || res.code !== 200) {
            try {
                res = await wiz.call("request_review", {
                    id: this.id,
                    ...reviewer
                });
            } catch (error: any) {
                res = { code: 500, message: error?.message || '' };
            }
        }
        this.isAssigningReviewer = false;
        if (res && res.code === 200) {
            await this.loadWorkflow();
            await this.service.modal.success("검토자가 지정되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "검토자를 지정하지 못했습니다."));
        }
        await this.service.render();
    }

    public async addReviewComment() {
        const message = (this.reviewComment || '').trim();
        if (!message) {
            await this.service.modal.error("검토 의견을 입력해주세요.");
            return;
        }
        if (this.isSavingComment) return;
        this.isSavingComment = true;
        await this.service.render();
        const reviewId = this.workflow.review?.id || '';
        const reviewer = this.reviewerPayload();
        const res = await wiz.call("add_review_comment", {
            id: this.id,
            review_id: reviewId,
            message,
            severity: this.reviewSeverity,
            ...reviewer
        });
        this.isSavingComment = false;
        if (res && res.code === 200) {
            this.reviewComment = '';
            await this.loadWorkflow();
            await this.service.modal.success("검토 의견이 등록되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "검토 의견을 저장하지 못했습니다."));
        }
        await this.service.render();
    }

    public async decideReview(decision: string) {
        if (this.isDecidingReview) return;
        this.isDecidingReview = true;
        this.activeReviewDecision = decision;
        await this.service.render();
        const reviewId = this.workflow.review?.id || '';
        const reviewer = this.reviewerPayload();
        const res = await wiz.call("decide_review", {
            id: this.id,
            review_id: reviewId,
            decision,
            note: this.reviewDecisionNote || '',
            ...reviewer
        });
        this.isDecidingReview = false;
        this.activeReviewDecision = '';
        if (res && res.code === 200) {
            this.reviewDecisionNote = '';
            await this.loadProject();
            await this.loadWorkflow();
            await this.service.modal.success(decision === 'approve' ? "설계안이 승인되었습니다." : "보완 요청이 등록되었습니다.");
        } else {
            await this.service.modal.error(this.apiErrorMessage(res, "검토 결정을 저장하지 못했습니다."));
        }
        await this.service.render();
    }

    public async switchTab(t: string) {
        if (!this.workflowTabs.some((item: any) => item.key === t)) return;
        if (!this.isNew) {
            this.service.href(this.projectUrl(t));
        }
        this.tab = t;
        await this.service.render();
    }

    public nextWorkflowTab() {
        const currentIndex = this.workflowTabs.findIndex((item: any) => item.key === this.tab);
        if (currentIndex >= 0 && currentIndex < this.workflowTabs.length - 1) {
            return this.workflowTabs[currentIndex + 1].key;
        }
        const actionTab = this.workflow.nextAction?.tab || this.tab || 'design';
        return this.workflowTabs.some((item: any) => item.key === actionTab) ? actionTab : 'design';
    }

    public async goNextWorkflowStep() {
        if (this.tab === 'design') {
            const saved = await this.save();
            if (!saved) return;
        }
        await this.switchTab(this.nextWorkflowTab());
    }

    public getStatusLabel(s: string) {
        return this.statuses.find(x => x.value === s)?.label || s;
    }

    private formatWorkflowCount(value: any) {
        const count = Number(value || 0);
        return `${Number.isFinite(count) ? count : 0}건`;
    }

    private formatWorkflowPercent(value: any) {
        if (value === null || value === undefined || value === '') return '-';
        return `${value}%`;
    }

    private workflowStepMetricsForStep(step: any, summary: any) {
        const key = step?.key || step?.tab || '';
        if (key === 'design') {
            return [
                { label: '설계 단계', value: summary.stage || '프로젝트 등록' },
                { label: '추천 후보', value: this.formatWorkflowCount(summary.recommendationCount) }
            ];
        }
        if (key === 'simulation') {
            return [
                { label: '시뮬레이션', value: this.formatWorkflowCount(summary.simulationCount) },
                { label: '최신 부하율', value: this.formatWorkflowPercent(summary.latestLoadRatio) },
                { label: '실측 일치도', value: this.formatWorkflowPercent(summary.digitalTwinMatch) }
            ];
        }
        if (key === 'documents') {
            return [
                { label: '보안 문서', value: this.formatWorkflowCount(summary.documentCount) },
                { label: '검수 대기', value: this.formatWorkflowCount(summary.documentPendingCount) },
                { label: '벡터 청크', value: this.formatWorkflowCount(summary.documentChunkCount) }
            ];
        }
        if (key === 'digital_twin') {
            return [
                { label: 'DT 검증', value: summary.digitalTwinStatus || '대기' },
                { label: '실측 샘플', value: this.formatWorkflowCount(summary.fieldSampleCount) },
                { label: '검증 게이트', value: summary.approvalReady ? '통과' : '확인' }
            ];
        }
        if (key === 'review') {
            return [
                { label: '검토 상태', value: summary.reviewStatusLabel || '검토 대기' }
            ];
        }
        if (key === 'reports') {
            return [
                { label: '리포트', value: this.formatWorkflowCount(summary.reportCount) }
            ];
        }
        return [];
    }

    public workflowStepClass(step: any) {
        let stateClass = 'border-slate-200 bg-white text-slate-500 shadow-sm shadow-slate-200/60 dark:border-white/10 dark:bg-slate-800 dark:text-slate-400 dark:shadow-none';
        if (step.state === 'done') {
            stateClass = 'border-emerald-200 bg-emerald-50 text-emerald-800 shadow-sm shadow-emerald-100/70 dark:border-emerald-400/30 dark:bg-emerald-400/10 dark:text-emerald-200 dark:shadow-none';
        } else if (step.state === 'current') {
            stateClass = 'border-cyan-200 bg-cyan-50 text-cyan-800 shadow-sm shadow-cyan-100/80 dark:border-cyan-300/40 dark:bg-cyan-300/10 dark:text-cyan-100 dark:shadow-none';
        }
        if (step.tab === this.tab) {
            return `${stateClass} -translate-y-1 border-transparent shadow-[0_18px_35px_rgba(8,145,178,0.24)] ring-1 ring-cyan-200/70 dark:ring-cyan-300/30`;
        }
        return stateClass;
    }

    public workflowStepStateLabel(step: any) {
        if (step.state === 'done') return '완료';
        if (step.state === 'current') return '진행';
        return '대기';
    }

    public gateClass(gate: any) {
        if (gate.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (gate.state === 'current') return 'border-cyan-200 bg-cyan-50 text-cyan-700';
        return 'border-slate-200 bg-slate-50 text-slate-500';
    }

    public reviewStatusClass(status: string) {
        const map: any = {
            approved: 'bg-emerald-100 text-emerald-700',
            rework: 'bg-amber-100 text-amber-700',
            in_review: 'bg-cyan-100 text-cyan-700',
            requested: 'bg-blue-100 text-blue-700',
            draft: 'bg-slate-100 text-slate-600'
        };
        return map[status] || map.draft;
    }

    public checklistClass(item: any) {
        return item.checked ? 'border-emerald-200 bg-emerald-50 text-emerald-800' : (item.required ? 'border-amber-200 bg-amber-50 text-amber-800' : 'border-slate-200 bg-slate-50 text-slate-600');
    }

    public commentClass(item: any) {
        const map: any = {
            success: 'bg-emerald-50 text-emerald-700',
            warning: 'bg-amber-50 text-amber-700',
            critical: 'bg-red-50 text-red-700',
            info: 'bg-slate-50 text-slate-600'
        };
        return map[item?.severity] || map.info;
    }

    public workflowProgressWidth() {
        return `${this.workflow.summary?.progress || 0}%`;
    }

    public canGenerateReport() {
        return this.workflow.review?.status === 'approved';
    }

    public canApproveReview() {
        return Boolean(this.workflow.digitalTwin?.validationGate?.approvalAllowed);
    }
}

export default PageProjectsItemComponent;